import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import { faFacebookF, faLinkedin, faGithubSquare } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./footer.scss";

function Footer() {
  const [date] = useState(new Date().getFullYear());

  return (
    <footer className="footer">
      <Container>
        <Row className="mb-5">
          <p className="col-12 text-center footer-title">
            Copyright © {date} All Rightes Reserved | This Website Is Made with Love by{" "}
            <span>Shmagi</span>
          </p>
        </Row>
        <Row>
          <div className="col-12 text-center">
            <p>
              <a
                href="https://www.facebook.com/shmagi.gavashelashvili.562"
                className="footer-socials"
                rel="noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon icon={faFacebookF} className="footer-socials-icons" />
              </a>
              <a
                href="https://linkedin.com/in/shmagi-gavashelashvili-58b7991aa"
                className="footer-socials"
                rel="noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon icon={faLinkedin} className="footer-socials-icons" />
              </a>
              <a
                href="https://github.com/shmagi-avro"
                className="footer-socials"
                rel="noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon icon={faGithubSquare} className="footer-socials-icons" />
              </a>
            </p>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
